import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
  CustomInput
} from "reactstrap";
import DateTime from 'react-datetime'
import moment from 'moment';
import InputMask from "react-input-mask";

import { getMessage } from "CONFIG/i18n";

//constants
import { REGEX } from "UTILS/Constants";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

import "./AddAnnouncementModal.less";
import "react-datetime/css/react-datetime.css";

class AddAnnouncementMOdal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activateFrom: "",
      activateTill: "",
      agentScreen: "",
      userURL: "",
      userPasscode: "",
      userQRCode: "",
      isActive: "",
      announcementData: _.isEmpty(this.props.announcementData)
        ? {
          agentScreen: true,
          userURL: false,
          userPasscode: false,
          userQRCode: false,
          isActive: true,
          title: "",
          message: "",
        }
        : _.cloneDeep(this.props.announcementData),
      isDataEdited:false
    }
  }

  componentWillUnmount() {
    this.disableAddBtn(false);
  }

  componentDidMount() {
    this.setInputDate();
  }

  resetState = () => {
    this.setState({
      announcementData: _.isEmpty(this.props.announcementData)
        ? {
          isActive: false
        }
        : _.cloneDeep(this.props.announcementData),
      isDataEdited:false
    })
  }

  handleCancelClick = () => {
    this.resetState();
    this.props.showAddAnnouncementModal(false);
  }

  validateEntries = () => {
    if(!this.state.announcementData.title || !this.state.announcementData.title.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_TITLE") });
      return false;
    }
    if(!this.state.announcementData.message || !this.state.announcementData.message.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_MESSAGE") });
      return false;
    }
    if(!this.state.announcementData.activateFrom) {
      this.setState({ errorMessage: getMessage("INVALID_ACTIVATE_FROM") });
      return false;
    }
    if(!this.state.announcementData.activateTill) {
      this.setState({ errorMessage: getMessage("INVALID_ACTIVATE_TILL") });
      return false;
    }

    let fromDateLimit = this.props.announcementData && 
    new Date(this.props.announcementData.activateFrom) < new Date() ? 
      new Date(this.props.announcementData.activateFrom) :
      new Date()
    if(new Date(this.state.announcementData.activateFrom) < fromDateLimit) { 
      this.setState({ errorMessage: getMessage("INVALID_ACTIVATE_FROM_DATE_VALUE") });
      return false;
    }

    if(moment(this.state.announcementData.activateTill).diff(moment(this.state.announcementData.activateFrom),'minutes') <= 0) {
      this.setState({ errorMessage: getMessage("INVALID_ACTIVATE_TILL_DATE_VALUE") });
      return false;
    }

    return true
  }

  handleAddClick = () => {
    if(!this.validateEntries()) {
      this.disableAddBtn(false);
      return;
    }
    let announcement = this.state.announcementData;
    announcement.title = announcement.title.trim();
    announcement.message = announcement.message.trim();

    if(this.state.isDataEdited)
    {
      this.props.updateAnnotation(announcement, (error) => {
        if(error) {
          console.error(error);
          this.setState({
            errorMessage: getMessage(error.code),
            isDataEdited:false
          })
          this.disableAddBtn(false)
        } else {
          this.props.showAddAnnouncementModal(false);
        }
      })
    }
    else{
      this.handleCancelClick();
    }
    this.disableAddBtn(true);
  }

  renderButtons = () => {
    return (
      <div>
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>
        <Button
          id="addAnnouncementBtn"  
          onClick={() => {
            this.disableAddBtn(true);
            this.handleAddClick();
          }
          }
          className="buttons customBtn whiteOnClick"
        >
          {this.props.saveBtnText}
        </Button>
      </div>
    );
  };

  //AgentScreen Handler
  handleAgentScreenOnChange = event => {
    this.setState({
      announcementData: {
        ...this.state.announcementData,
        [event.target.name]: [event.target.name]=="agentScreen"
          ?event.target.checked
          :event.target.value
      },
      isDataEdited: true
    });
  }
  
  //UserURL Handler
  handleUserURLOnChange = event => {
    this.setState({
      announcementData: {
        ...this.state.announcementData,
        [event.target.name]: [event.target.name]=="userURL"
          ?event.target.checked
          :event.target.value
      },
      isDataEdited: true
    });
  }

  //UserPasscode Handler
  handleUserPasscodeOnChange = event => {
    this.setState({
      announcementData: {
        ...this.state.announcementData,
        [event.target.name]: [event.target.name]=="userPasscode"
          ?event.target.checked
          :event.target.value
      },
      isDataEdited: true
    });
  }

  //UserQRCode Handler
  handleUserQRCodeOnChange = event => {
    this.setState({
      announcementData: {
        ...this.state.announcementData,
        [event.target.name]: [event.target.name]=="userQRCode"
          ?event.target.checked
          :event.target.value
      },
      isDataEdited: true
    });
  }
  
  handleInputChange = event => {
    this.setState({
      announcementData: {
        ...this.state.announcementData,
        [event.target.name]: [event.target.name]=="isActive"
          ?event.target.checked
          :event.target.value
      },
      isDataEdited:true
    });
    if (this.state.errorMessage) {
      this.setState({ errorMessage: "" });
    }
  };

  onChange = (value, name) => {
    if(!moment(value).isValid())
    {
      (name==="activateFrom") ?
        this.setState({errorMessage:"INVALID_ACTIVATE_FROM_DATE"}) :
        this.setState({errorMessage:"INVALID_ACTIVATE_TILL_DATE"})
    }else {
      this.setState({errorMessage:""})
      !this.state.announcementData.activateTill && this.refs.tilldate.setViewDate( value )
    }
    let announcementData = this.state.announcementData;
    announcementData[name] = value
    this.setState({
      announcementData: announcementData,
      isDataEdited:true
    },()=>{this.setInputDate()})
    if (this.state.errorMessage) {
      this.setState({ errorMessage: "" });
    }
    
  }

  disableAddBtn = (value) => {
    let addBtn = document.getElementById("addAnnouncementBtn");
    if(addBtn){
      addBtn.disabled = value;
      if(value)
        addBtn.classList.add("pointerEventsNone");
      else
        addBtn.classList.remove("pointerEventsNone");
    }
  }

  minTillDate =(date)=> {
    let activateFrom= this.state.announcementData.activateFrom;
    if(activateFrom){
      return date.isAfter(activateFrom) || date.isSame(activateFrom,'day')
    } else {
      return date.isAfter(moment()) || date.isSame(moment(),'day')
    }
  }

  handleChangeDate =(event)=> {
    this.setState({[event.target.name]: event.target.value})
    if(!event.target.value.includes('_') && event.target.value){
      this.onChange(moment(event.target.value), event.target.name)
    }
  }

  setInputDate =()=> {
    this.setState({
      activateFrom: this.state.announcementData.activateFrom ? 
        moment(this.state.announcementData.activateFrom).format("YYYY/MM/DD HH:mm") :
        "",
      activateTill: this.state.announcementData.activateTill ?
        moment(this.state.announcementData.activateTill).format("YYYY/MM/DD HH:mm") :
        ""
    })
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        backdrop="static"
        className="addAnnouncementModal"
        toggle={this.props.handleCancelClick}
      >
        <ModalHeader className="popupHeader">
          {this.props.headerText}
        </ModalHeader>
        <ModalBody className="pb-0">
          <Form>
            <FormGroup className="displayFlex alignItemsCenter">
              <Label className="label">
                {getMessage("TITLE")}
              </Label>
              <Input
                type="text"
                name="title"
                id="title"
                className="inputFormControl"
                value={this.state.announcementData.title}
                onChange={this.handleInputChange}
                maxLength="100"
              />
            </FormGroup>
            <FormGroup className="displayFlex alignItemsCenter">
              <Label className="label">{getMessage("MESSAGE")}</Label>
              <Input
                type="textarea"
                rows={4}
                // type="text"
                name="message"
                id="message"
                onChange={this.handleInputChange}
                className="inputFormControl"
                value={this.state.announcementData.message}
                maxLength="500"
              />
            </FormGroup>
            <FormGroup className="displayFlex alignItemsCenter">
              <Label className="label">{getMessage("ACTIVATE_FROM")}</Label>
              <div className="datePicker">

                <DateTime 
                  className="w-100" 
                  id="activateFrom"  
                  onChange={(value) => this.onChange(value, "activateFrom")}
                  value={this.state.announcementData && 
                    this.state.announcementData.activateFrom && 
                    moment(this.state.announcementData.activateFrom)}
                  initialViewDate={this.state.announcementData &&
                    this.state.announcementData.activateFrom ?
                    moment(this.state.announcementData.activateFrom):
                    moment()}
                  closeOnSelect
                  isValidDate={(date)=>{return date.isAfter(moment()) || date.isSame(moment(),'day')}}
                  onClose={()=>this.setInputDate()}
                  renderInput={(props, openCalendar)=> 
                    <InputMask 
                      className="rounded-pill w-100 border formControlName form-control text-center cursorPointer"
                      mask="yyyy/Mo/De HH:mi"
                      name="activateFrom"
                      readOnly={true}
                      value={this.state.activateFrom}
                      placeholder="YYYY/MM/DD HH:mm"
                      formatChars={REGEX.DATE_TIME_PATTERN}
                      onFocus={()=>openCalendar()}
                      onChange={this.handleChangeDate}
                      onKeyPress={this.handleKeyPress}
                    />}
                />

                <Label className="label dateToLabel px-5">
                  &nbsp;{getMessage("ACTIVATE_TILL")}&nbsp;
                </Label>
               
                <DateTime
                  className="w-100" 
                  onChange={(value) => this.onChange(value, "activateTill")}
                  value={this.state.announcementData && 
                    this.state.announcementData.activateTill &&
                    moment(this.state.announcementData.activateTill)}
                  ref="tilldate"
                  initialViewDate={this.state.announcementData &&
                    this.state.announcementData.activateTill ?
                    moment(this.state.announcementData.activateTill):
                    moment(this.state.announcementData.activateFrom)}
                  renderMonth={2}
                  closeOnSelect
                  isValidDate={this.minTillDate}
                  onClose={()=>this.setInputDate()}
                  renderInput={(props, openCalendar)=> 
                    <InputMask 
                      className="rounded-pill w-100 border formControlName form-control text-center cursorPointer"
                      mask="yyyy/Mo/De HH:mi"
                      name="activateTill"
                      readOnly={true}
                      value={this.state.activateTill}
                      placeholder="YYYY/MM/DD HH:mm"
                      formatChars={REGEX.DATE_TIME_PATTERN}
                      onFocus={()=>openCalendar()}
                      onChange={this.handleChangeDate}
                      onKeyPress={this.handleKeyPress}
                    />}
                />
              </div>
              
            </FormGroup>
            <FormGroup className="displayFlex alignItemsCenter">
              <Label className="label">{getMessage("TARGET_SCREEN")}</Label>
              <CustomInput
                className="customCheckbox"
                type="checkbox"
                id='agentScreen'
                name='agentScreen'
                defaultChecked={this.state.announcementData.agentScreen}
                onChange={this.handleAgentScreenOnChange}
              /> <Label className="label">{getMessage("AGENT_SCREEN")}</Label>
              <CustomInput
                className="customCheckbox"
                type="checkbox"
                id='userURL'
                name='userURL'
                defaultChecked={this.state.announcementData.userURL}
                onChange={this.handleUserURLOnChange}
              /> <Label className="label">{getMessage("USER_URL_SCREEN")}</Label>
              <CustomInput
                className="customCheckbox"
                type="checkbox"
                id='userPasscode'
                name='userPasscode'
                defaultChecked={this.state.announcementData.userPasscode}
                onChange={this.handleUserPasscodeOnChange}
              /> <Label className="label">{getMessage("USER_PASSCODE_SCREEN")}</Label>
              <CustomInput
                className="customCheckbox"
                type="checkbox"
                id='userQRCode'
                name='userQRCode'
                defaultChecked={this.state.announcementData.userQRCode}
                onChange={this.handleUserQRCodeOnChange}
              /> <Label className="label">{getMessage("USER_QRCODE_SCREEN")}</Label>
            </FormGroup>            
            <FormGroup className="displayFlex alignItemsCenter mb-0">
              <Label className="label">{getMessage("IS_ACTIVE")}</Label>
              <CustomInput
                className="customCheckbox"
                type="checkbox"
                id='isActive'
                name='isActive'
                defaultChecked={this.state.announcementData.isActive}
                onChange={this.handleInputChange}
              />
            </FormGroup>
            <div className="errors">{getMessage(this.state.errorMessage)}</div>
          </Form>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    )
  }
}
export default modalScrollBar(AddAnnouncementMOdal);
